import i18n from "~/i18n";

export const API_STATE = {
	ready: "READY",
	loading: "LOADING",
	done: "DONE",
	error: "ERROR",
};

export const PAGE_STATE = {
	LOADING: "LOADING",
	EMPTY: "EMPTY",
	VIEW: "VIEW",
	EDIT: "EDIT",
};

export const INVEST_STATE = {
	WAITING: i18n.t("common.constants.state.waiting"),
	CONFIRM: i18n.t("common.constants.state.confirm"),
	REJECT: i18n.t("common.constants.state.reject"),
	COMPLETE: i18n.t("common.constants.state.complete"),
};
